import React from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Loading from '../Loading';

const DataComponentTableOffer = ({
    data: propData,
    loading: propLoading,
    columnData: propColumnData,
    t
}) => {
    const staticNames = t?.dataTable || {};

    const getKey = (data) => {
        if (React.isValidElement(data)) {
            return getKey(data.props.children);
        }

        return data;
    };

    return (
        <div className="loading-wrapper">
            {propLoading && propData.length
                ? <div className="loading-wrapper__item"><Loading /></div>
                : null
            }

            <div className="offers__wrapper">
                {(propData || []).map((item, i) => {
                    return (
                        <div className="offer" key={getKey(item.id || i)}>
                            {Object.keys(item).map((key, j) => {
                                const data = propColumnData.body[j] || {};
                                let value;

                                if (typeof item[key] === 'object') {
                                    value = item[key];
                                } else if (typeof item[key] === 'string'){
                                    value = Parser(item[key]);
                                }

                                if(value === undefined) {
                                    return;
                                }

                                return <div className={key} key={j} {...data}>{value}</div>
                            })}
                        </div>
                    )
                })}
                {!propData.length
                    ? propLoading
                        ? <Loading center={true} />
                        : <div className="text-center table-notfound-sign">{ staticNames.noData}</div>
                    : null
                }
            </div>

        </div>
    );
};

DataComponentTableOffer.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    columnData: PropTypes.object,
    t: PropTypes.object
};

DataComponentTableOffer.defaultProps = {
    data: [],
    loading: false,
    columnData: { body: {} }
};

export default withTranslation(DataComponentTableOffer);